import { useXcoreQuery } from "@robe/client/xcore-ui";
import { useMemo } from "react";
import { WebUser } from "@robe/core";

export const useUser = () => {
  const { data: user, ...rest } = useXcoreQuery<WebUser | null>((core) => core.web.getLoggedInWebUser(), {
    dedupingInterval: 20_000,
    ctx: {},
  });

  return useMemo(() => ({ user, ...rest }), [rest, user]);
};
